import React, { useState, useEffect } from "react";
import { Button, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { CalenderIcon } from "../Icon";
import ReactDatePicker from "react-datepicker";

type AppProps = {
  handleDateChange: (data: any) => void;
  date: Date | string;
  isOpen: boolean;
  toggle: () => void;
  setCopyData: any;
  setIsCopy:(e:any)=>void;
  setIsEdit:(e:any)=>void;
  setComment:React.Dispatch<React.SetStateAction<string>>;
  copyData: any;
  setCopyComment:React.Dispatch<React.SetStateAction<boolean>>;
  copyComment:boolean
};
const CopyTimeSheet = ({
  date,
  handleDateChange,
  isOpen,
  toggle,
  setCopyData,
  setComment,
  copyData,
  setIsCopy,
  setIsEdit,
  setCopyComment,
  copyComment
}: AppProps) => {
  const [copyTimeSheetData, setCopyTimeSheetData] = useState<any>(null);

  const handleSelectDate = () => {
    if (copyTimeSheetData) {
      handleDateChange?.(copyTimeSheetData);
      toggle()
      setIsCopy(true)
      setIsEdit(false)
    }
    };

    useEffect(()=>{
      setIsCopy(false)
    })
  
    
  return (
    <div>
      <Modal  isOpen={isOpen}
        toggle={toggle}
        centered
        backdrop="static">
        <ModalHeader 
          id='cross-cut'
          toggle={toggle}
        >
          <span>Copy Timesheet Entry</span>
        </ModalHeader>
        <ModalBody>
          <span>
            Are you sure you want to copy this timesheet entry to the date
            selected?
          </span>
          <div className="col-md-8 pl-0 mt-2 mb-2">
             <label className="mb-1" htmlFor="">
            Date
          </label>
          <div className="form-group">
            <div className="date-picker-wraper mr-0 position-relative">
              <Label className="m-0 p-0 w-100 d-flex">
                <ReactDatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    copyTimeSheetData
                      ? new Date(
                          moment(`${copyTimeSheetData}T00:00:00`, "DD-MM-YYYY").format(
                            "YYYY-MM-DD[T]HH:mm:ss"
                          )
                        )
                      : null
                  }
                  onChange={(e: any) => {
                    setCopyTimeSheetData( 
                      e ? moment(e).format("DD-MM-YYYY") : null
                    );
                  }}
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  placeholderText="Select"
                  className="form-control pointer"
                />
                <span
                  className="calender-icon"
                  style={{ right: "10px", cursor: "pointer" }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
            </div>
             </div>

          
          <div className="row">
            <div className="col-md-8 pl-3 pr-3">
              
         <div  style={{ textAlign: "left", display: "flex",gap:"7px" }}>
        <input
          type="checkbox"
          style={{
            width: "19px",
            height: "19px",
            backgroundColor: "red",
            accentColor: " #dd4433",
          }}
          onChange={() => setCopyComment((prev:any)=>!prev)}
          className="checkbox"
          />
        <span>Copy Comment</span>
      </div>
          </div>
          </div>
          <div className="mt-3 card-buttons" >
            <div >
              <button className="btn btn-outline-secondary mr-1" onClick={() => {
                toggle();
                setCopyData({})
              }
              }>Cancel</button>
            </div>
            <div>
              <button disabled={!copyTimeSheetData} className="btn btn-primary pl-4 pr-4"  onClick={handleSelectDate}>Yes</button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default CopyTimeSheet;
